import { typographyTokens } from '@/shared/lib/design-tokens'

export const tokenSectionMeta = {
  colors: {
    label: 'Colors',
    description: 'Brand, semantic, neutral, text, background, and border colors.',
  },
  typography: {
    label: 'Typography',
    description: 'Font families and type scales with real font sizes and weights.',
  },
  spacing: {
    label: 'Spacing',
    description: 'Spacing scale for padding, gaps, and layout rhythm.',
  },
  radii: {
    label: 'Radii',
    description: 'Corner radius tokens for cards, pills, and containers.',
  },
  shadows: {
    label: 'Shadows',
    description: 'Elevation tokens for cards, panels, and overlays.',
  },
  borders: {
    label: 'Borders',
    description: 'Border widths and styles used in the system.',
  },
  effects: {
    label: 'Global effects',
    description: 'Noise overlays, blur, and shadow effects applied across screens.',
  },
} as const

export type TokenSectionId = keyof typeof tokenSectionMeta

export const tokenSections = (
  Object.entries(tokenSectionMeta) as [TokenSectionId, (typeof tokenSectionMeta)[TokenSectionId]][]
).map(([id, meta]) => ({ id, ...meta }))

export const fontFamilyTokens = typographyTokens.filter((token) =>
  token.path.startsWith('typography.fontFamilies.')
)
export const typeScaleTokens = typographyTokens.filter(
  (token) => !token.path.startsWith('typography.fontFamilies.')
)

export const sampleText = 'The quick brown fox jumps over the lazy dog.'
